export const COLOURS = {
  // Killi brand, data sharing, & data revolution
  fuchsiaPink: '#FF009D',
  fuchsiaPinkDarken: '#7F004E',
  // Redeem & badges
  fuchsiaPurple: '#343399',
  // Verification & privacy
  aqua: '#17D1CF',
  // Warnings
  mango: '#FEBA4A',
  // Dark body copy
  black: '#000000',
  blackShadow: 'rgba(0, 0, 0, 0.1)',
  blackShadow2: 'rgba(0, 0, 0, 0.05)',
  textBlack: '#333333',
  blackHaze: '#F4F5F5',
  // Link, category label, section title
  darkGrey: '#77797F',
  darkGrey1: '#5A5A5A',
  darkGrey2: '#707070',
  darkGrey3: '#444444',
  darkGrey4: '#6C757D',
  darkGrey5: '#525252',
  darkGrey6: '#333333',
  darkGrey7: '#808080',
  darkGrey8: '#313131',
  darkGrey9: '#A3A3A3',
  darkGrey10: '#C4C4C4B2',
  labelGrey: '#595959',
  // Link icon, meta data
  lightGrey: '#A0A5AA',
  lightGrey2: '#E6E6E6',
  lightGrey3: '#949494',
  lightGrey4: '#B3B3B3',
  lightGrey5: '#B2B6B6',
  lightGrey6: '#FAFAFA',
  lightGrey7: '#D9D9D9',
  ultraLightGrey: '#EDEDED',
  gunSmoke: '#808282',
  lightZircon: '#E2F0F0',

  maroonCustom: '#A22856',
  orange: '#F2520D',
  strongOrange: '#F9550F',

  errorText: '#DC3545',

  // Border & dividers
  silver1: '#D3D3D3',
  iron: '#D8DBDB',
  // Background
  silver2: '#EDEFF1',
  // Light body copy
  white: '#FFFFFF',
  whiteSmoke: '#F5F5F5',
  lightwhiteSmoke: '#F9FBFB',
  strongWhiteSmoke: '#EAE6E6',
  translucent: 'rgba(255,255,255,0.5)',
  transparent: 'transparent',
  fbBlue: '#4267B2',
  grey: '#D3E2E2',
  greenGrey2: '#91B6B6',

  greenGrey: '#E8F0F0',
  paleGrey: '#EDEFF1',
  paleYellow: '#FAFBE8',
  yellow: '#FFD100',
  strongPink: '#D72A98',
  darkTurquoise: '#17D1CF',
  green: '#199021',
  aquaGreen: '#EDFFDB',
  lightTurquoise: '#009BF514',
  turquoise1: '#2CD0CD',
  turquoise2: '#00D4E2',
  tiaMaria: '#DF410F',
  blueGem: '#461098',
  razzmatazz: '#F3075C',

  killiBackgroundColor: '#E5E5E5',
  hollywoodCerise: '#FF0096',
  hollywoodCeriseDarken: '#D9006F',
  mercury: '#E5E5E5',
  intakeSurveyFooterLine: '#C5DEDE',
  intakeSurveyCheckboxOutline: '#D3E2E2',
  intakeSurveyBlue: '#343399',
  violetEggplant: '#B812A6',
  royalBlue: '#297EE6',
  darkBlue: '#3645AE',
  blue: '#0FCBDF',
  lightBlue: '#46109B',
  darkPurple: '#6B35C6',
  lightOrange: '#F4AB70',
  purple: '#46109B',
  purpleBackground: '#E8E3F0',
  fadedPurple: '#F6F3FA',
  purpleHeart: '#6A11CB',
  dodgerBlue: '#2575FC',
  pink: '#F4AB70',
  peach: '#CF019B',
  havelockBlue: '#4F9CD8',
  fadedBlue: '#7857C7',
  governorBay: '#3645AE',
  lightPurple: '#EAE0FF',
  lightPurple2: '#DBD3EA',

  governorBayBG: 'rgba(54, 69, 174, 0.3)',
  hollywoodCeriseBG: 'rgba(255, 0, 150, 0.3)',
  darkPurpleBG: 'rgba(107, 53, 198, 0.3)',
  lightOrangeBG: 'rgba(244,171,112,0.3)',
  fadedRed: '#D07676',
  fadedGreen: '#83CC64',

  // modals background color
  greyModal: '#F4F5F5',

  // card linear gradient
  cardPurple: '#46109B',
  // Table header
  tableHeaderBackground: '#C6CDCD',
  // FAQ border
  faqBorderGrey: '#E2F0F0',

  // dividends
  dividendGradientBlue: '#7ACAE6',
  tiara: '#C6CDCD',
  shoppingRewardBlue: '#3476E1',
  referAFriendPurple: '#7857C7',
  unlockCardBlueGradient: '#049AF7',
  dividendsBadgeGreen: '#9CCC5A',
  dividendsBadgeYellow: '#FFD100',

  // Surveys
  disabledArrow: '#B6B6B6',

  // Design System
  primaryYellow: '#FFDF03',
  primaryBlue: '#2432C8',
  secondaryRed1: '#F95055',
  secondaryRed2: '#F9A894',
  secondaryPurple1: '#6C37CE',
  secondaryPurple2: '#B6B0FF',
  secondaryPurple3: '#F9F5FF',
  neutralBlack: '#000000',
  neutralWhite: '#FFFFFF',
  neutralGrey1: '#FAFAFA',
  neutralGrey2: '#EFEFEF',
  neutralGrey3: '#C7C7C7',
  neutralGrey4: '#A0A0A0',
  neutralGrey5: '#505050',
  systemYellow1: '#EFD100',
  systemYellow2: '#FFF5B1',
  systemOrange1: '#F09A37',
  systemOrange2: '#FFE2AE',
  systemOrange3: '#FFFAEB',
  systemGreen: '#067647',
  systemGreen1: '#65C466',
  systemGreen2: '#ADF5B6',
  systemBrown1: '#B54708',
  utilitySuccess50: '#E6FDF3',
}

// Bootstrap Breakpoints
// Reference: https://getbootstrap.com/docs/4.1/layout/overview/#responsive-breakpoints
export const BREAKPOINTS = {
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
}
export const BREAKPOINTS_MAX = {
  sm: '575.98px',
  md: '767.98px',
  lg: '991.98px',
  xl: '1199.98px',
}

export const SYMBOLS = {
  checkmark: '✓', // &#10003;
  xMark: '✗', // &#10007;
  dot: '•', // &#8226;
  plus: '+',
  minus: '-',
}

export const WEBSITE_URL = 'https://reklaimyours.com'

export const MIN_AGE_BY_REGION = {
  CA: 16,
  US: 16,
  AU: 16,
  NZ: 16,
  SG: 16,
}

export const MIN_DATE_OF_BIRTH = '1900-01-01'

export const COUNTRY_DIVISION_DISPLAY = {
  CA: 'Province',
  US: 'State',
}

export const COUNTRY_DISPLAY = {
  CA: 'Canada',
  US: 'United States',
  AU: 'Australia',
  SG: 'Singapore',
  NZ: 'New Zealand',
}

export const POSTAL_CODE_DISPLAY = {
  CA: 'Postal Code',
  US: 'Zip Code',
  SG: 'Postal Code',
  NZ: 'Postcode',
  AU: 'Postcode',
}

export const POSTAL_CODE_EXAMPLE = {
  CA: 'A1A 1A1',
  US: '12345 (5 numeric digits)',
  SG: '123456 (6 numeric digits)',
  NZ: '1234 (4 numeric digits)',
  AU: '1234 (4 numeric digits)',
}

export const SUPPORT_EMAIL = 'support@reklaimyours.com'

export const PHONE_FORMAT_BY_REGION = {
  CA: {
    mask: '+1 (###) ### ####',
    placeholder: '+1 (000) 000 0000',
    maxLength: 17,
    minLength: 17,
  },
  US: {
    mask: '+1 (###) ### ####',
    placeholder: '+1 (000) 000 0000',
    maxLength: 17,
    minLength: 17,
  },
  AU: {
    mask: '+61 # #### ####',
    placeholder: '+61 0 0000 0000',
    maxLength: 15,
    minLength: 15,
  },
  NZ: {
    mask: '+64 ## #### ####',
    placeholder: '+64 00 0000 0000',
    maxLength: 16,
    minLength: 14,
  },
  SG: {
    mask: '+65 #### ####',
    placeholder: '+65 0000 0000',
    maxLength: 13,
    minLength: 13,
  },
}

export const QUESTION_TYPE = {
  phoneNumber: 'phoneNumber',
  verificationCode: 'verificationCode',
  gender: 'gender',
}

export const EMAIL_VERIFICATION_RESEND_TIMEOUT_MS = 5000

export const COPY_TO_CLIPBOARD_TIMEOUT_MS = 3000

export const EVENT_TYPE = {
  // Survey
  surveyLoad: 'Survey.Load',
  surveyClick: 'Survey.Click',
  surveyComplete: 'Survey.Complete',
  surveyScreenOut: 'Survey.ScreenOut',
  surveyPayableScreenOut: 'Survey.PayableScreenOut',
  // KilliSurvey
  killiSurveyLoad: 'KilliSurvey.Load',
  killiSurveyClick: 'KilliSurvey.Click',
  killiSurveyExit: 'KilliSurvey.Exit',
  killiSurveyComplete: 'KilliSurvey.Complete',
  // IdentityScreen
  identityScreenLoad: 'IdentityScreen.Load',

  // LogIn
  logInView: 'LogIn.View',
  logInSignInClick: 'LogIn.SignInClick',
  logInFailure: 'LogIn.Failure',
  logInSubmit: 'LogIn.Submit',
  logInCodeView: 'LogIn.CodeView',
  logInCodeSuccess: 'LogIn.CodeSuccess',
  logInCodeFailure: 'LogIn.CodeFailure',
  logInCodeResend: 'LogIn.CodeResend',
  // Latent
  latentAccountCreateAccountView: 'LatentAccount.CreateAccountView',
  latentAccountCreateAccountFail: 'LatentAccount.CreateAccountFail',
  latentAccountCreateAccountSuccess: 'LatentAccount.CreateAccountSuccess',
  latentAccountAccountAlreadyCreatedView: 'LatentAccount.AccountAlreadyCreatedView',
  latentAccountAccountNotFoundView: 'LatentAccount.AccountNotFoundView',
  // HomeScreen
  homeScreenLoad: 'HomeScreen.Load',
  // Identity Screen
  identityScreenOptOutClick: 'IdentityScreen.OptOutClick',
  identityScreenOptOutConfirm: 'IdentityScreen.OptOutConfirm',
  identityScreenOptIn: 'IdentityScreen.OptIn',
  identityScreenDataDownloadClick: 'IdentityScreen.DataDownloadClick',
  identityScreenDataDownloaded: 'IdentityScreen.DataDownloaded',
  identityScreenDataDownloadJSONLinkClick: 'IdentityScreen.DataDownloadJSONLinkClick',
  walletHistoryLinkClick: 'Wallet.HistoryLinkClick',
  walletRedemptionPage: 'Wallet.RedemptionPage',
  accountDelete: 'Account.Delete',
  accountDeleteConfirm: 'Account.DeleteConfirm',
  accountSignOut: 'Account.SignOut',
  unauthorizedAccountSignOutRedirect: 'UnauthorizedAccount.SignOutRedirect',
  revenue: 'Revenue.Revenue',

  // Jackpot
  jackpotShow: 'Jackpot.Show',
  jackpotDelete: 'Jackpot.Delete',
  jackpotEdit: 'Jackpot.Edit',
  jackpotAdd: 'Jackpot.Add',

  // Protect
  protectView: 'Protect.View',
  protectSignDataBrokerContract: 'Protect.SignDataBrokerContract',
  protectVoidDataBrokerContract: 'Protect.VoidDataBrokerContract',

  // Store
  walletRewardsCategoryClick: 'WalletRewards.CategoryClick',
  walletRedeemClick: 'Wallet.RedeemClick',
  storeView: 'Store.View',

  // Shares
  redemptionSharesRequirementsView: 'Redemption.SharesRequirementsView',
  redemptionSharesRequested: 'Redemption.SharesRequested',
  redemptionSharesAutoOptIn: 'Redemption.SharesAutoOptIn',
  sharesForRedemption: 'SharesForRedemption',

  // Social Share
  redemptionShareCopyLink: 'RedemptionShare.CopyLink',
  redemptionShareMyLink: 'RedemptionShare.MyLink',
  redemptionShareReturnToApp: 'RedemptionShare.ReturnToApp',

  // Refer a Friend
  referAFriendView: 'ReferAFriend.View',
  referAFriendCopyClick: 'ReferAFriend.CopyClick',
  referAFriendNavMenuCTAClick: 'ReferAFriend.NavMenuCTAClick',
  signUpReferredView: 'SignUp.ReferredView',
  signUpReferredSubmittedSuccess: 'SignUp.ReferredSubmittedSuccess',

  // Redemption
  captchaFail: 'Captcha.Fail',
  redemptionLoad: 'Redemption.Load',
  redemptionRequested: 'Redemption.Requested',
  redemptionRequestConfirmed: 'Redemption.RequestConfirmed',
  redemptionPayPalLoad: 'Redemption.PayPalLoad',
  redemptionPayPalRequested: 'Redemption.PayPalRequested',
  redemptionPayPalRequestConfirmed: 'Redemption.PayPalRequestConfirmed',
  redemptionVenmoLoad: 'Redemption.VenmoLoad',
  redemptionVenmoRequested: 'Redemption.VenmoRequested',
  redemptionVenmoRequestConfirmed: 'Redemption.VenmoRequestConfirmed',

  appLaunchAppLaunch: 'AppLaunch.AppLaunch',
  appInit: 'App.Init',

  // Dividends
  audienceDividendView: 'AudienceDividend.View',
  audienceDividendShareProfile: 'AudienceDividend.ShareProfile',
  audienceDividendSkipClick: 'AudienceDividend.SkipClick',
  profileRewardsScreenEditClick: 'ProfileRewardsScreen.EditClick',
  profileRewardsScreenEditConfirmClick: 'ProfileRewardsScreen.EditConfirmClick',
  profileRewardsScreenSyncClick: 'ProfileRewardsScreen.SyncClick',
  financialDividendDeleteAccountConfirm: 'FinancialDividend.DeleteAccountConfirm',
  financialDividendDeleteAccountClick: 'FinancialDividend.DeleteAccountClick',
  financialDividendView: 'FinancialDividend.View',
  financialDividendSignUpClick: 'FinancialDividend.SignUpClick',
  financialDividendSignUpFastLinkEvent: 'FinancialDividend.SignUpFastLinkEvent',
  financialDividendSignUpSuccess: 'FinancialDividend.SignUpSuccess',
  financialDividendSignUpExit: 'FinancialDividend.SignUpExit',
  financialDividendSignUpError: 'FinancialDividend.SignUpError',
  financialDividendOptOutClick: 'FinancialDividend.OptOutClick',
  financialDividendOptOutConfirm: 'FinancialDividend.OptOutConfirm',
  financialDividendOptInClick: 'FinancialDividend.OptInClick',
  browsingRewardsView: 'BrowsingRewards.View',
  browsingRewardsOptInClick: 'BrowsingRewards.OptInClick',
  browsingRewardsOptOutClick: 'BrowsingRewards.OptOutClick',
  browsingRewardsOptOutConfirmClick: 'BrowsingRewards.OptOutConfirmClick',
  browsingRewardsOptOutCancelClick: 'BrowsingRewards.OptOutCancelClick',
  browsingRewardsCopyUserCodeClick: 'BrowsingRewards.CopyUserCodeClick',
  browsingRewardsExtensionDownloadCTAClick: 'BrowsingRewards.ExtensionDownloadCTAClick',
  browsingRewardsAutoSetRequestSent: 'BrowsingRewards.AutoSetRequestSent',
  browsingRewardsAutoSetResponseReceived: 'BrowsingRewards.AutoSetResponseReceived',
  browsingRewardsAutoSetSuccess: 'BrowsingRewards.AutoSetSuccess',
  deviceRewardsView: 'DeviceRewards.View',
  deviceRewardsOptOutClick: 'DeviceRewards.OptOutClick',
  deviceRewardsOptOutConfirmClick: 'DeviceRewards.OptOutConfirmClick',

  // Tasks Section
  discoverRewardsLevelCarouselFinancialClick: 'Discover.RewardsLevelCarouselFinancialClick',
  discoverRewardsLevelCarouselAudienceClick: 'Discover.RewardsLevelCarouselAudienceClick',
  discoverRewardsLevelCarouselBrowse: 'Discover.RewardsLevelCarouselBrowse',
  discoverRewardsLevelCarouselClosedCard: 'Discover.RewardsLevelCarouselClosedCard',
  discoverRewardsLevelCarouselBrowsingClick: 'Discover.RewardsLevelCarouselBrowsingClick',
  discoverRewardsLevelCarouselDeviceClick: 'Discover.RewardsLevelCarouselDeviceClick',

  // Earn Rewards Card
  discoverRewardsAudienceClick: 'Discover.RewardsAudienceClick',
  discoverRewardsBrowsingClick: 'Discover.RewardsBrowsingClick',
  discoverReferAFriendRewardsClick: 'Discover.ReferAFriendRewardsClick',
  discoverRewardsDeviceClick: 'Discover.RewardsDeviceClick',
  discoverRewardsFinancialClick: 'Discover.RewardsFinancialClick',

  // Region error
  regionErrorView: 'RegionError.View',

  // No Internet Connection
  noNetworkAccessView: 'NoNetworkAccess.View',

  // Locked by admin
  accountLockedScreenView: 'AccountLockedScreen.View',
  accountLockedScreenAcknowledgeClick: 'AccountLockedScreen.AcknowledgeClick',

  // Unveil Prompt
  unveilPromptModalView: 'UnveilPromptModal.View',
  unveilPromptModalContinueClick: 'UnveilPromptModal.ContinueClick',
  unveilPromptModalCloseClick: 'UnveilPromptModal.CloseClick',
  // Unveil Sign Up
  unveilSignUpScreenView: 'UnveilSignUpScreen.View',
  // Unveil Sign Up - Partial Unveil
  unveilScanningScreenView: 'UnveilScanningScreen.View',
  unveilNotFoundScreenContinueClick: 'UnveilNotFoundScreen.ContinueClick',
  unveilNotFoundScreenTryAgainClick: 'UnveilNotFoundScreen.TryAgainClick',
  unveilNotFoundScreenSignUpClick: 'UnveilNotFoundScreen.SignUpClick',
  unveilNotFoundScreenCreateAccountClick: 'UnveilNotFoundScreen.CreateAccountClick',
  unveilSummaryScreenView: 'UnveilSummaryScreen.View',
  unveilSummaryScreenContinueClick: 'UnveilSummaryScreen.ContinueClick',
  unveilExplainerScreenView: 'UnveilExplainerScreen.View',
  unveilExplainerScreenContinueClick: 'UnveilExplainerScreen.ContinueClick',
  unveilReklaimPrivacyExplainerScreenView: 'UnveilReklaimPrivacyExplainerScreen.View',
  unveilReklaimPrivacyExplainerScreenContinueCTA: 'UnveilReklaimPrivacyExplainerScreen.ContinueCTA',
  unveilReklaimPrivacyExplainerScreenBackClick: 'UnveilReklaimPrivacyExplainerScreen.BackClick',
  // Unveil Notification Modal
  unveilNotificationModalSkipClick: 'UnveilNotificationModal.SkipClick',
  unveilNotificationModalContinueClick: 'UnveilNotificationModal.ContinueClick',
  unveilNotificationModalView: 'UnveilNotificationModal.View',
  // Unveil Summary Screen
  unveilSummaryScreenLearnMoreClick: 'UnveilSummaryScreen.LearnMoreClick',
  unveilSummaryScreenLearnMoreModalView: 'UnveilSummaryScreen.LearnMoreModalView',
  // Full Unveil
  fullUnveilScanningView: 'FullUnveil.ScanningView',
  fullUnveilProfileNotFoundView: 'FullUnveil.ProfileNotFoundView',
  fullUnveilProfileNotFoundViewPlansClick: 'FullUnveil.ProfileNotFoundViewPlansClick',
  fullUnveilProfileNotFoundContinueClick: 'FullUnveil.ProfileNotFoundContinueClick',
  fullUnveilProfileNotFoundCloseClick: 'FullUnveil.ProfileNotFoundCloseClick',
  fullUnveilProfileNotFoundAddEmailClick: 'FullUnveil.ProfileNotFoundAddEmailClick',
  fullUnveilUnveilAttributesModalView: 'FullUnveil.UnveilAttributesModalView',
  fullUnveilUnveilAttributesModalViewPlansClick: 'FullUnveil.UnveilAttributesModalViewPlansClick',
  fullUnveilUnveilAttributesModalContinueClick: 'FullUnveil.UnveilAttributesModalContinueClick',
  fullUnveilUnveilAttributesView: 'FullUnveil.UnveilAttributesView',
  fullUnveilUnveilAttributesAddClick: 'FullUnveil.UnveilAttributesAddClick',
  fullUnveilUnveilAttributesSkipClick: 'FullUnveil.UnveilAttributesSkipClick',
  fullUnveilSuccessfullyAddedModalView: 'FullUnveil.SuccessfullyAddedModalView',
  fullUnveilSuccessfullyAddedModalContinueClick: 'FullUnveil.SuccessfullyAddedModalContinueClick',
  fullUnveilDataBreachClick: 'FullUnveil.DataBreachClick',
  fullUnveilDataBreachModalCloseClick: 'FullUnveilDataBreachModalCloseClick',
  fullUnveilDataBreachPasswordExplainerLabelClick: 'FullUnveil.DataBreachPasswordExplainerLabelClick',
  // Full Unveil Conflict Resolution
  fullUnveilConflictFoundModalView: 'FullUnveil.ConflictFoundModalView',
  fullUnveilConflictFoundModalManualMergeClick: 'FullUnveil.ConflictFoundModalManualMergeClick',
  fullUnveilConflictFoundModalAutoMergeClick: 'FullUnveil.ConflictFoundModalAutoMergeClick',
  fullUnveilConflictResolutionView: 'FullUnveil.ConflictResolutionView',
  fullUnveilConflictResolutionQuestionView: 'FullUnveil.ConflictResolutionQuestionView',
  fullUnveilConflictResolutionNextClick: 'FullUnveil.ConflictResolutionNextClick',
  fullUnveilConflictResolutionBackClick: 'FullUnveil.ConflictResolutionBackClick',
  // Full Unveil Associated Ids
  fullUnveilAssociatedIdModalView: 'FullUnveil.AssociatedIdModalView',
  fullUnveilAssociatedIdModalUpdateClick: 'FullUnveil.AssociatedIdModalUpdateClick',
  fullUnveilAssociatedIdModalCancelClick: 'FullUnveil.AssociatedIdModalCancelClick',
  fullUnveilPrivacyCardClick: 'FullUnveil.PrivacyCardClick',
  // Breach Notification Explainer
  breachNotificationExplainerScreenView: 'BreachNotificationExplainerScreen.View',
  breachNotificationExplainerScreenClick: 'BreachNotificationExplainerScreen.Click',
  // VPN Explainer Screen
  vpnExplainerScreenView: 'VPNExplainerScreen.View',
  vpnExplainerScreenClick: 'VPNExplainerScreen.Click',
  // Crypto Redemption
  redeemSelectionScreenView: 'RedeemSelectionScreen.View',
  redeemSelectionScreenGiftCardClick: 'RedeemSelectionScreen.GiftCardClick',
  redeemSelectionScreenCryptoClick: 'RedeemSelectionScreen.CryptoClick',
  redeemCryptoAmountScreenView: 'RedeemCryptoAmountScreen.View',
  redeemCryptoAmountScreenContinueClick: 'RedeemCryptoAmountScreen.ContinueClick',
  redeemCryptoWalletScreenView: 'RedeemCryptoWalletScreen.View',
  redeemCryptoWalletScreenPasteAddressClick: 'RedeemCryptoWalletScreen.PasteAddressClick',
  redeemCryptoWalletScreenWhereToGetWalletClick: 'RedeemCryptoWalletScreen.WhereToGetWalletClick',
  redeemCryptoWalletScreenContinueClick: 'RedeemCryptoWalletScreen.ContinueClick',
  redeemCryptoConfirmationScreenView: 'RedeemCryptoConfirmationScreen.View',
  redeemCryptoConfirmationScreenNetworkFeeTooltipClick: 'RedeemCryptoConfirmationScreen.NetworkFeeTooltipClick',
  redeemCryptoConfirmationScreenRequestClick: 'RedeemCryptoConfirmationScreen.RequestClick',
  redeemCryptoRequestedScreenView: 'RedeemCryptoRequestedScreen.View',
  redeemCryptoRequestedScreenContinueClick: 'RedeemCryptoRequestedScreen.ContinueClick',
  redeemCryptoRateExpiredModalView: 'RedeemCryptoRateExpiredModal.View',
  redeemCryptoRateExpiredModalRestartClick: 'RedeemCryptoRateExpiredModal.RestartClick',

  // My Footprint Screen
  myFootprintScreenView: 'MyFootprintScreen.View',
  myFootprintScreenDataBuyerLinkClick: 'MyFootprintScreen.DataBuyerLinkClick',
  myFootprintScreenDataSellerClick: 'MyFootprintScreen.DataSellerClick',
  myFootprintScreenDataBreachClick: 'MyFootprintScreen.DataBreachClick',
  myFootprintScreenDataBreachModalClose: 'MyFootprintScreen.DataBreachModalClose',
  myFootprintScreenPrivacyCardClick: 'MyFootprintScreen.PrivacyCardClick',
  myFootprintScreenScanCTA: 'MyFootprintScreen.ScanCTA',
  myFootprintScreenDataBreachPasswordExplainerLabelClick: 'MyFootprintScreen.DataBreachPasswordExplainerLabelClick',

  dataBreachExplainerModalCloseClick: 'DataBreachExplainerModal.CloseClick',
  dataSellerExplainerModalCloseClick: 'DataSellerExplainerModal.CloseClick',
  // Account - Email Addresses - Add
  accountEmailAddressAddClick: 'Account.EmailAddressAddClick',
  accountAddEmailAddressModalEnterEmailAddressView: 'AccountAddEmailAddressModal.EnterEmailAddressView',
  accountAddEmailAddressModalEnterEmailAddressSubmitClick: 'AccountAddEmailAddressModal.EnterEmailAddressSubmitClick',
  accountAddEmailAddressModalEnterEmailAddressSubmitFailure:
    'AccountAddEmailAddressModal.EnterEmailAddressSubmitFailure',
  accountAddEmailAddressModalEnterEmailAddressSubmitSuccess:
    'AccountAddEmailAddressModal.EnterEmailAddressSubmitSuccess',
  accountAddEmailAddressModalVerifyEmailAddressView: 'AccountAddEmailAddressModal.VerifyEmailAddressView',
  accountAddEmailAddressModalVerifyEmailAddressResendClick: 'AccountAddEmailAddressModal.VerifyEmailAddressResendClick',
  accountAddEmailAddressModalVerifyEmailAddressSubmit: 'AccountAddEmailAddressModal.VerifyEmailAddressSubmit',
  accountAddEmailAddressModalVerifyEmailAddressSubmitFailure:
    'AccountAddEmailAddressModal.VerifyEmailAddressSubmitFailure',
  accountAddEmailAddressModalVerifyEmailAddressSubmitSuccess:
    'AccountAddEmailAddressModal.VerifyEmailAddressSubmitSuccess',
  accountAddEmailAddressModalVerificationSuccessView: 'AccountAddEmailAddressModal.VerificationSuccessView',
  // Account - Email Addresses - Remove
  accountEmailAddressRemoveClick: 'Account.EmailAddressRemoveClick',
  accountEmailAddressRemoveModalView: 'Account.EmailAddressRemoveModalView',
  accountEmailAddressRemoveModalConfirmClick: 'Account.EmailAddressRemoveModalConfirmClick',
  accountEmailAddressRemoveModalConfirmFailure: 'Account.EmailAddressRemoveModalConfirmFailure',
  accountEmailAddressRemoveModalConfirmSuccess: 'Account.EmailAddressRemoveModalConfirmSuccess',
  // Account - Email Addresses - Set Primary
  accountEmailAddressSetPrimaryClick: 'Account.EmailAddressSetPrimaryClick',
  accountEmailAddressSetPrimaryFailure: 'Account.EmailAddressSetPrimaryFailure',
  accountEmailAddressSetPrimarySuccess: 'Account.EmailAddressSetPrimarySuccess',
  // Account - Phone Numbers - Add
  accountPhoneNumberAddClick: 'Account.PhoneNumberAddClick',
  accountAddPhoneNumberModalEnterPhoneNumberView: 'AccountAddPhoneNumberModal.EnterPhoneNumberView',
  accountAddPhoneNumberModalEnterPhoneNumberSubmitClick: 'AccountAddPhoneNumberModal.EnterPhoneNumberSubmitClick',
  accountAddPhoneNumberModalEnterPhoneNumberSubmitFailure: 'AccountAddPhoneNumberModal.EnterPhoneNumberSubmitFailure',
  accountAddPhoneNumberModalEnterPhoneNumberSubmitSuccess: 'AccountAddPhoneNumberModal.EnterPhoneNumberSubmitSuccess',
  accountAddPhoneNumberModalVerifyPhoneNumberView: 'AccountAddPhoneNumberModal.VerifyPhoneNumberView',
  accountAddPhoneNumberModalVerifyPhoneNumberResendClick: 'AccountAddPhoneNumberModal.VerifyPhoneNumberResendClick',
  accountAddPhoneNumberModalVerifyPhoneNumberCodeSubmit: 'AccountAddPhoneNumberModal.VerifyPhoneNumberCodeSubmit',
  accountAddPhoneNumberModalVerifyPhoneNumberCodeSubmitFailure:
    'AccountAddPhoneNumberModal.VerifyPhoneNumberCodeSubmitFailure',
  accountAddPhoneNumberModalVerifyPhoneNumberCodeSubmitSuccess:
    'AccountAddPhoneNumberModal.VerifyPhoneNumberCodeSubmitSuccess',
  accountAddPhoneNumberModalVerificationSuccessView: 'AccountAddPhoneNumberModal.VerificationSuccessView',
  // Account - Phone Numbers - Remove
  accountPhoneNumberRemoveClick: 'Account.PhoneNumberRemoveClick',
  accountPhoneNumberRemoveModalView: 'Account.PhoneNumberRemoveModalView',
  accountPhoneNumberRemoveModalConfirmClick: 'Account.PhoneNumberRemoveModalConfirmClick',
  accountPhoneNumberRemoveModalConfirmFailure: 'Account.PhoneNumberRemoveModalConfirmFailure',
  accountPhoneNumberRemoveModalConfirmSuccess: 'Account.PhoneNumberRemoveModalConfirmSuccess',
  // Account - Phone Numbers - Set Primary
  accountPhoneNumberSetPrimaryClick: 'Account.PhoneNumberSetPrimaryClick',
  accountPhoneNumberSetPrimaryFailure: 'Account.PhoneNumberSetPrimaryFailure',
  accountPhoneNumberSetPrimarySuccess: 'Account.PhoneNumberSetPrimarySuccess',
  // Account - Verify Associated Ids
  accountEmailAddressVerifyAssociatedClick: 'Account.EmailAddressVerifyAssociatedClick',
  accountPhoneNumberVerifyAssociatedClick: 'Account.PhoneNumberVerifyAssociatedClick',
  accountIDsUpgradeOptionsClick: 'Account.IDsUpgradeOptionsClick',
  // Account - User Handle
  accountUserHandleUpdateClick: 'Account.UserHandleUpdateClick',
  accountUserHandleUpdateModalView: 'Account.UserHandleUpdateModalView',
  accountUserHandleUpdateModalSaveClick: 'Account.UserHandleUpdateModalSaveClick',
  // Account - Profile Picture
  accountProfilePictureUpdateClick: 'Account.ProfilePictureUpdateClick',
  accountProfilePictureUpdateModalView: 'Account.ProfilePictureUpdateModalView',
  accountProfilePictureUploadSuccess: 'Account.ProfilePictureUploadSuccess',
  accountProfilePictureUploadFailure: 'Account.ProfilePictureUploadFailure',
  accountProfilePictureModalCancelClick: 'Account.ProfilePictureModalCancelClick',

  // Deep link
  branchDeepLinkOpen: 'BranchDeeplink.Open',

  // Reklaim Screen
  reklaimScreenSubscriptionCTAClick: 'ReklaimScreen.SubscriptionCTAClick',
  reklaimScreenIntercomClick: 'ReklaimScreen.IntercomClick',

  // Subscription Screen
  subscriptionScreenView: 'SubscriptionScreen.View',
  subscriptionScreenEmailDownloadLinkClick: 'SubscriptionScreen.EmailDownloadLinkClick',
  subscriptionScreenNoThanksClick: 'SubscriptionScreen.NoThanksClick',

  // Earn More Flow
  earnFromDataCTAClick: 'EarnFromData.CTAClick',

  // Polls Explainer
  pollsExplainerScreenView: 'PollsExplainerScreen.View',
  pollsExplainerScreenSkipClick: 'PollsExplainerScreen.SkipClick',

  // Polls Intake Survey
  pollsIntakeSurveyStartClick: 'PollsIntakeSurvey.StartClick',
  pollsIntakeSurveyView: 'PollsIntakeSurvey.View',
  pollsIntakeSurveyExit: 'PollsIntakeSurvey.Exit',
  pollsIntakeSurveyConfirmExit: 'PollsIntakeSurvey.ConfirmExit',
  pollsIntakeSurveyComplete: 'PollsIntakeSurvey.Complete',

  // Sign Up Fork (Welcome Screen)
  welcomeScreenCompensationClick: 'WelcomeScreen.CompensationClick',
  welcomeScreenPrivacyClick: 'WelcomeScreen.PrivacyClick',
  earnFromDataExplainerScreenBackClick: 'EarnFromDataExplainerScreen.BackClick',

  // Active Paycheck
  activePaycheckPopupView: 'ActivePaycheckClaim.View',
  activePaycheckClaimClick: 'ActivePaycheckClaim.Click',
}

export const BRANCH_EVENTS = {
  openApp: 'open_app',
  loginSuccess: 'login.success',
  signUpSuccess: 'signup.success',
  fullUnveilSubscriptionCta: 'full_unveil_subscription_cta',
  partialUnveil: 'partial_unveil',
  fullUnveil: 'full_unveil',
  subscriptionScreen: 'subscription_screen',
}

export const POLLFISH_SURVEY_STATUSES = {
  SUCCESS: 'C',
  PAYABLE_SCREENOUT: 'O',
  FAILURE: 'F',
}

export const REKLAIM_SURVEY_SUCCESS_STATUS = 'C'

export const EXTERNAL_SURVEY_SUBMISSION_EVENT = 'ExternalSurveySubmitted'
export const EXTERNAL_SURVEY_FAILURE_EVENT = 'ExternalSurveyFailure'

export const SIGN_UP_SCREENS = {
  screenEnter: 'enter',
  screenValidation: 'validation',
}

export const REQUEST_RESOLVE_MINIMUM_TIME_MS = 500

export const RESET_ACTION_TYPE = 'RESET'

export const FETCH_STATUSES = {
  NOOP: 'noop',
  FETCHING: 'fetching',
  SUCCESS: 'success',
  FAILURE: 'failure',
}

export const REWARDS_LEVEL = {
  ZERO: 0,
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
}

export const REWARDS_LEVEL_BAR_BACKGROUND = {
  ONE: 'linear-gradient(90deg, #513CBA 56.44%, #852BBD 102.24%);',
  TWO: 'linear-gradient(90deg, #892ABC 0%, #E4099E 100%);',
  THREE: 'linear-gradient(90deg, #EC069C 0%, #F95184 100%);',
  FOUR: 'linear-gradient(90deg, #F95982 0%, #F4AB70 100%);',
}

export const REWARDS_FLAT_AMOUNTS = {
  [REWARDS_LEVEL.ZERO]: 0,
  [REWARDS_LEVEL.ONE]: 0.25,
  [REWARDS_LEVEL.TWO]: 0.5,
  [REWARDS_LEVEL.THREE]: 0.75,
  [REWARDS_LEVEL.FOUR]: 1,
}

export const PENDING_NOTIFICATION_MODAL_TYPE = {
  REFERRAL_REFEREE_IN_PROGRESS: 'referral_referee_in_progress',
  REFERRAL_REFERRER_BONUS_AMOUNT: 'referral_referrer_bonus',
  REFERRAL_REFEREE_BONUS_AMOUNT: 'referral_referee_bonus',
}

// Crypto
export const ENABLE_CRYPTO_REDEMPTION_FEES = true
export const CRYPTO_KEYS = {
  BITCOIN: 'bitcoin',
  ETHEREUM: 'ethereum',
  USDC: 'usdc',
}

export const SIGN_UP_TYPE = {
  EMAIL: 'email',
  PHONE_NUMBER: 'phone-number',
}

export const UNVEIL_TYPE = {
  NEW_USER: 'new-user',
  EXISTING_USER: 'existing-user',
}

export const UNVEIL_DATA_SOURCE = {
  FACEBOOK: 'facebook',
  DATA_BROKERS: 'data-brokers',
}

export const YODLEE_FASTLINK_STATUSES = {
  SUCCESS: 'success',
  FAILURE: 'failure',
}

export const SUBSCRIPTION_TYPE = {
  BASIC: 'basic',
  LITE: 'lite',
  PRO: 'pro',
}

export const SCREEN_TYPE = {
  ONBOARDING_FLOW: 'onboardingFlow',
  EARN_MORE_FLOW_REKLAIM_SCREEN: 'existingUserFlowReklaimScreen',
  EARN_MORE_FLOW_MY_DATA_SCREEN: 'existingUserFlowMyDataScreen',
  REKLAIM_SCREEN: 'reklaimScreen',
  MY_DATA_SCREEN: 'myDataScreen',
  POLLS_SCREEN: 'pollsScreen',
}

export const FORK_SIGN_UP_TYPE = {
  PRIVACY: 'privacy',
  COMPENSATION: 'compensation',
}

export const CREATE_ACCOUNT_TYPE = {
  PRIVACY_PARTIAL_UNVEIL_FOUND: 1,
  PRIVACY_PARTIAL_UNVEIL_NOT_FOUND: 2,
  COMPENSATION: 3,
}
